import { useState, useCallback, useEffect } from 'react'

export function useColumnResize(columnManager) {
  const [resizing, setResizing] = useState(null)

  const handleMouseDown = useCallback(
    (e, columnId) => {
      e.preventDefault()
      setResizing(columnId)
      const currentWidth = columnManager.getWidth(columnId)
      columnManager.startResize(columnId, e.clientX, currentWidth)
      document.body.style.cursor = 'col-resize'
      document.body.style.userSelect = 'none'
    },
    [columnManager]
  )

  const handleMouseMove = useCallback(
    (e) => {
      if (!resizing) return
      const result = columnManager.updateResize(e.clientX)
      if (result) {
        columnManager.setWidth(result.id, result.width)
      }
    },
    [resizing, columnManager]
  )

  const handleMouseUp = useCallback(() => {
    if (resizing) {
      columnManager.endResize()
      setResizing(null)
      document.body.style.cursor = ''
      document.body.style.userSelect = ''
    }
  }, [resizing, columnManager])

  useEffect(() => {
    if (resizing) {
      document.addEventListener('mousemove', handleMouseMove)
      document.addEventListener('mouseup', handleMouseUp)
      return () => {
        document.removeEventListener('mousemove', handleMouseMove)
        document.removeEventListener('mouseup', handleMouseUp)
      }
    }
  }, [resizing, handleMouseMove, handleMouseUp])

  return { handleMouseDown }
}
